// Product card Add to Cart (snippets/product-item.liquid). Shared site-wide:
// homepage rows, collections, recommendations. Moved out of
// sections/collection--test.liquid so every card gets the behavior. One
// delegated listener, so carousel clones and re-rendered sections work too.
(function () {
  document.addEventListener('click', function (e) {
    var button = e.target.closest('.product-item-add-to-cart-btn');
    if (!button) return;

    e.preventDefault();

    var productId = button.getAttribute('data-product-id');
    var productItem = button.closest('.product-item');

    if (button.disabled || !productItem) {
      return;
    }

    // Check if we need to show size selector or add to cart directly
    if (button.textContent.trim() === 'ADD TO CART') {
      showSizeSelection(button, productId, productItem);
    }
  });

  function showSizeSelection(button, productId, productItem) {
    // Get product handle from the product link
    var productLink = productItem.querySelector('a.product-item__image-link, .product-item__product-title a');
    var productHandle = productId;

    if (productLink) {
      var href = productLink.getAttribute('href');
      if (href && href.includes('/products/')) {
        productHandle = href.split('/products/')[1].split('?')[0];
      }
    }

    // Fetch product data to get variants
    fetch('/products/' + productHandle + '.js')
      .then(function (response) { return response.json(); })
      .then(function (product) {
        // Get unique sizes from variants. Only an option actually named "Size"
        // counts; option1 is often Purchase Frequency or Number Of Packs.
        var uniqueSizes = new Map();
        var sizeIndex = -1;

        (product.options || []).forEach(function (option, i) {
          var name = typeof option === 'string' ? option : option.name;
          if (sizeIndex === -1 && /size/i.test(name || '')) sizeIndex = i;
        });

        product.variants.forEach(function (variant) {
          var size = sizeIndex === -1 ? null : variant['option' + (sizeIndex + 1)];

          if (size) {
            // Extract text before parentheses
            size = size.split('(')[0].trim();

            // Only add if we haven't seen this size or if this variant is available and the stored one isn't
            if (!uniqueSizes.has(size) || (variant.available && !uniqueSizes.get(size).available)) {
              uniqueSizes.set(size, variant);
            }
          }
        });

        var sizeVariants = Array.from(uniqueSizes.values());

        if (sizeVariants.length > 1) {
          button.textContent = 'Select size';

          // Mobile: the image overlay is too narrow (sizes truncate to "S." "X.")
          // and sits above the tapped button, so show the sizes right above it.
          var sizeSelector;
          if (window.matchMedia('(max-width: 768px)').matches) {
            var cartArea = button.closest('.product-item__add-to-cart');
            sizeSelector = cartArea.querySelector('.product-item__size-selector');
            if (!sizeSelector) {
              sizeSelector = document.createElement('div');
              sizeSelector.className = 'product-item__size-selector';
              cartArea.insertBefore(sizeSelector, cartArea.firstChild);
            }
          } else {
            sizeSelector = productItem.querySelector('.product-item__size-selector-overlay');
          }
          if (!sizeSelector) {
            // Fallback: create container in product media if not found
            var productMedia = productItem.querySelector('.product-item__media');
            if (productMedia) {
              sizeSelector = document.createElement('div');
              sizeSelector.className = 'product-item__size-selector-overlay';
              productMedia.appendChild(sizeSelector);
            }
          }

          if (sizeSelector) {
            sizeSelector.innerHTML = '';

            // Long labels ("Small/Medium", "Ultimate - Long Length") get one per row
            var stacked = sizeVariants.some(function (variant) {
              return variant['option' + (sizeIndex + 1)].split('(')[0].trim().length > 4;
            });
            sizeSelector.classList.toggle('product-item__size-selector--stacked', stacked);

            // Create size buttons for unique sizes
            sizeVariants.forEach(function (variant) {
              var sizeButton = document.createElement('button');
              sizeButton.type = 'button';
              sizeButton.className = 'product-item__size-button';

              var sizeText = variant['option' + (sizeIndex + 1)];
              sizeText = sizeText.split('(')[0].trim();

              sizeButton.textContent = sizeText;
              sizeButton.disabled = !variant.available;

              if (!variant.available) {
                sizeButton.setAttribute('aria-label', sizeText + ' - Sold Out');
              }

              sizeButton.addEventListener('click', function (ev) {
                // The overlay sits on the image link; don't navigate to the PDP
                ev.preventDefault();
                ev.stopPropagation();
                addToCart(variant.id, productId, sizeButton);
              });

              sizeSelector.appendChild(sizeButton);
            });

            sizeSelector.classList.add('active');
            if (sizeSelector.classList.contains('product-item__size-selector')) {
              sizeSelector.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }
          }
        } else {
          // Product doesn't have multiple size variants, add to cart directly
          addToCart(product.variants[0].id, productId, button);
        }
      })
      .catch(function (error) {
        console.error('Error fetching product data:', error);
        alert('Error loading product information. Please try again.');
      });
  }

  function addToCart(variantId, productId, button) {
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      button.disabled = false;
      button.textContent = originalText;

      // Handle Shopify errors
      if (data && (data.status >= 400 || data.message || data.description)) {
        alert(data.description || data.message || 'Error adding item to cart');
        return;
      }

      // Try to update cart drawer if it exists
      if (typeof $ !== 'undefined' && $('.js-cart-drawer-section').length) {
        $.ajax({
          url: '/?section_id=new-cart-drawer',
          type: 'GET',
          dataType: 'html',
          success: function (carthtml) {
            var newContent = $(carthtml).find('.js-cart-drawer-section').html();
            $('.js-cart-drawer-section').html(newContent);

            // Update cart count and open drawer
            $.getJSON('/cart.js', function (cart) {
              $('.js-cart-item-count').text(cart.item_count);
              $('.js-cart-drawer-section').addClass('active');
              $('.js-cart-drawer-overlay').addClass('active');
              $('body').addClass('overflow-hidden');
            });
          },
          error: function () {
            window.location.href = '/cart';
          }
        });
      } else {
        window.location.href = '/cart';
      }

      // Dispatch custom event for other scripts
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: {
          variant_id: variantId,
          product_id: productId,
          product_data: data
        }
      }));
    })
    .catch(function (error) {
      button.disabled = false;
      button.textContent = originalText;

      console.error('Error adding to cart:', error);
      alert('Error adding item to cart. Please try again.');
    });
  }
})();
